<button
  class="filter-select"
  (click)="openFiltersModal()"
  aria-label="Show more filters"
  aria-haspopup="dialog"
 >
  <div class="filter-select-inner-container">
    <span *ngIf="numSelections > 0" class="placeholder-text">
      More <span class="filters-label-text"> filters </span>
    </span>
    <span *ngIf="numSelections == 0" class="placeholder-text">
      More filters
    </span>
    <span *ngIf="numSelections > 0" class="filter-select-overflow-count">
      {{ numSelections }}
    </span>
    <iris-icon
      name="expand_more"
      class="filter-select-toggle"
      [size]="mediumIconSize"
      [usage]="decorativeIconUsage"
    ></iris-icon>
  </div>
</button>
